export const sortBrands = (brands: string[]): string[] => {
    return [...brands].sort((a, b) => a.trim().localeCompare(b.trim(), undefined, { sensitivity: 'base' }));
};
